import { useStore } from 'dg-web-shared/lib/Flux.tsx';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import * as TomCollectionsState from '../../state/TomCollectionsState.ts';
import * as CollectionsActions from '../../actions/CollectionsActions.ts';
import { tomFilterTexts } from '../../i18n/TomTexts.ts';
import { TomFilter, TomFilterHalfSlideIn } from '../TomFilterHalfSlideIn.tsx';

export function TomFilterCollectionsListSlideIn() {
    const { storeState, update } = useStore(store => ({
        filter: TomCollectionsState.Filter.get(store),
    }));
    const { language } = useLanguage();

    const texts = tomFilterTexts[language];
    const filter: TomFilter = {
        selectedToms: storeState.filter.toms,
    };
    return (
        <TomFilterHalfSlideIn
            filter={filter}
            open={storeState.filter.tomSelectionVisible}
            setSelection={(tomIds: number[]) =>
                update(store => CollectionsActions.setToms(store, tomIds))
            }
            onClose={() => update(CollectionsActions.closeTomFilter)}
            title={texts.filterTitle()}
        />
    );
}
